import {Component, EventEmitter, HostListener, OnDestroy, OnInit, Output} from '@angular/core';
import {Event, NavigationStart, Router, RouterEvent, RouterStateSnapshot} from '@angular/router';
import {LogoutAction} from "../../actions/auth.actions";
import {Select, Store} from "@ngxs/store";
import {AuthState} from "../../states/auth.state";
import {media} from './media';
import {UserProfileState} from "../../states/user-profile.state";
import {Observable, Subscription} from "rxjs";
import {MessageState} from "../../states/message.state";
import {GetMessageListAction} from "../../actions/message.actions";
import {AccountState} from "../../states/account.state";
import { DomSanitizer } from '@angular/platform-browser';
import { GetSocialMediaLinksAction } from 'src/app/actions/masters.actions';
import { Menu01Icon, Notification01Icon, ArrowDown01Icon, AccountSetting01Icon, LogoutSquare02Icon } from '@hugeicons-pro/core-stroke-rounded';
declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() menuClick = new EventEmitter<void>();

  Menu01Icon = Menu01Icon;
  ArrowDown01Icon = ArrowDown01Icon;
  AccountSetting01Icon = AccountSetting01Icon;
  LogoutSquare02Icon = LogoutSquare02Icon;

  sm$ = media(`(min-width: 576px)`);
  md$ = media(`(min-width: 768px)`);
  lg$ = media(`(min-width: 992px)`);
  xl$ = media(`(min-width: 1200px)`);
  xxl$ = media(`(min-width: 1400px)`);

  isSm = false;
  isMd = false;
  isLg = false;
  isXl = false;
  isXXl = false;

  @Select(AccountState.getAccountPersonalData)
  personalData$: Observable<any>;

  @Select(AuthState.getUserInfo)
  userInfo$: Observable<any>;

  @Select(UserProfileState.getUserPartner)
  userPartner$: Observable<any>;

  @Select(UserProfileState.getUserProfileImage)
  profileImage$: Observable<string>;

  @Select(MessageState.getNewMessageList)
  newMessageList$: Observable<any[]>;

  personalData: any;
  personalDataNombreCompleto = '';

  userPartner: any;
  profileImage = 'assets/img/img-04.jpg';

  socialMediaLinks$: Observable<any>;
  socialMediaLinks: any;

  showTerminos = false;
  showProfile = true;
  showRegister = false;
  showAccounts = false;

  Notification01Icon = Notification01Icon;

  private subscriptions: Subscription[] = [];

  constructor(
    private store: Store,
    public router: Router,
    private sanitizer: DomSanitizer
  ) {
    this.listenToRouteEvents();
  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    const header = document.getElementById('header');
    if (!header) return;

    if (window.scrollY > 100) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  }

  ngOnInit(): void {
    this.registerSubscriptions();
    this.evaluateRouteState(this.router.url);
  }

  private registerSubscriptions(): void {
    this.subscriptions.push(
      this.sm$.subscribe(matches => (this.isSm = matches)),
      this.md$.subscribe(matches => (this.isMd = matches)),
      this.lg$.subscribe(matches => (this.isLg = matches)),
      this.xl$.subscribe(matches => (this.isXl = matches)),
      this.xxl$.subscribe(matches => (this.isXXl = matches)),

      this.personalData$.subscribe(personalData => {
        console.log('personal data', personalData)
        if (personalData) {
          this.personalData = personalData;
          this.personalDataNombreCompleto = `${personalData.name ?? ''} ${personalData.lastName ?? ''}`.trim();
        }
      }),

      this.profileImage$.subscribe(img => {
        this.profileImage = img || 'assets/img/img-04.jpg';
      }),

      this.userPartner$.subscribe(userPartner => {
        this.userPartner = userPartner;
      })
    );

    this.socialMediaLinks$ = this.store.dispatch(new GetSocialMediaLinksAction());
    this.subscriptions.push(
      this.socialMediaLinks$.subscribe(state => {
        this.socialMediaLinks = state?.masters?.socialMediaLinks;
      })
    );
  }

  private listenToRouteEvents(): void {
    this.subscriptions.push(
      this.router.events.subscribe((event: Event | RouterEvent) => {
        if (event instanceof NavigationStart) {
          this.evaluateRouteState(event.url);

          if (event.url?.includes('user-account-details')) {
            this.store.dispatch(new GetMessageListAction({ page: 0, size: 50 }));
          }

          const splitVal = event.url.split('/');
          const base = splitVal[1];

          const body = document.body;

          if (base === 'dashboard' || base === 'user-account-details' || base === 'home') {
            this.showProfile = true;
            this.showRegister = false;
            this.showAccounts = false;
          } else if (
            base === 'login' ||
            base === 'register' ||
            base === 'forgot-password' ||
            base === 'change-password'
          ) {
            this.showProfile = false;
            this.showRegister = true;
            this.showAccounts = false;
          }

          if (base === 'home') {
            body.classList.add('home-page');
            body.classList.remove('dashboard-page');
          } else {
            body.classList.add('dashboard-page');
            body.classList.remove('home-page');
          }
        }
      })
    );
  }

  private evaluateRouteState(url: string): void {
    const authRoutes = [
      '/login',
      '/reset-password',
      '/forgot-password',
      '/register',
      '/thank-you',
      '.well-known/assetlinks.json'
    ];

    // this.isLogin = authRoutes.some(route => url.includes(route));
    this.showTerminos = url.includes('terminos-condiciones');

    // if (this.isLogin) {
    //   this.showProfile = false;
    // }
  }

  onMenuClick(): void {
    this.menuClick.emit();
  }

  gotoMessageList(): void {
    this.router.navigate(['/message-list']);
  }

  gotoAccount(): void {
    this.router.navigate(['/user-account-details']);
  }

  logout(): void {
    this.store.dispatch(new LogoutAction());
  }

  get partnerPhoneUrl() {
    if (!this.userPartner?.telefonos?.[0]?.phoneNumber) return null;

    return this.sanitizer.bypassSecurityTrustUrl(
      'whatsapp://send?phone=' + this.userPartner.telefonos[0].phoneNumber
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub?.unsubscribe());
  }
}